import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Dashboard from './navigation/App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <Dashboard/>,
  document.getElementById('root')
);

reportWebVitals();
